import React from "react";
import classNames from "classnames";
import "./styles/ColorBox.scss";

const greyStyle = {
  backgroundColor: "#f7f7f7",
  border: "1px solid #e2e2e2",
  padding: "1rem",
  lineHeight: "1.6",
  width: "100%",
};

const darkGreyStyle = {
  backgroundColor: "#e9e9e9",
  border: "1px solid #cbcccf",
  padding: "1rem",
  lineHeight: "1.6",
  width: "100%",
};

const colorResolver = (color) => {
  const colorOptions = {
    grey: greyStyle,
    darkGrey: darkGreyStyle,
  };
  return colorOptions[color] || greyStyle;
};

const ColorBox = ({ color, className, children }) => (
  <div
    style={colorResolver(color)}
    className={classNames(className, "colorbox")}
  >
    {children}
  </div>
);

export default ColorBox;
